module.exports = __webpack_public_path__ + "static/phigora-macbook@2x-1024x908-1d5fa8ed1f6fe316b9eefa28b21faf06.png";